import React, { memo } from 'react';
import TimePeriodDropdown, {
  getAtlasBeaconTimePeriods
} from 'src/components/BeaconV2Components/common/TimePeriodDropdown';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import ComparisonPeriodDropdown from 'src/components/BeaconV2Components/common/ComparisonPeriodDropdown';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import { Box } from '@mui/material';
import { useGetCurrencies } from '../../hooks/useGetCurrencies';
import { Controller } from 'react-hook-form';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';

export default memo(function WeekRangeSelect() {
  const currencies = useGetCurrencies();
  const { selections: { control } } = usePresentationFormContext();

  return (
    <Flex flexDirection="column" gap={32}>
      <Flex flexDirection="column" gap={8}>
        <Text variant="h4" lineHeight="28px">
          Time Period and Currency
        </Text>
        <Box fontSize={16} lineHeight="24px">
          Select the comparison periods and currency to use for this presentation.
        </Box>
      </Flex>
      <Flex>
        <Flex width="336px" flexDirection="column" gap={8}>
          <Text
            variant="h7"
            sx={{
              fontWeight: 500
            }}
          >
            Time Period
          </Text>
          <Flex gap={8} alignItems="center">
            <TimePeriodDropdown allowedTimePeriods={getAtlasBeaconTimePeriods} placement="bottom-start" />
            vs.
            <ComparisonPeriodDropdown />
          </Flex>
        </Flex>
        <Flex flex={1} flexDirection="column" gap={8}>
          <Text
            variant="h7"
            sx={{
              fontWeight: 500
            }}
          >
            Currency
          </Text>
          <Flex gap={8} alignItems="center">
            <Controller
              control={control}
              name="currency"
              render={({ field }) => (
                <SlDropdownMenu
                  onChange={(value) => field.onChange(value.id)}
                  selectedId={field.value}
                  options={currencies?.map((currency) => ({
                    id: currency.id,
                    label: `${currency.name} (${currency.id})`
                  }))}
                />
              )}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});
